<template>
    <div>

        <member-list-link :listLayout="listLayout" :paginationData="filterSet.page"
                          :memberData="List"></member-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :listLength="List.length" :type="memberType"></pagination-link>
    </div>
</template>

<script>
import MemberListLink from "@/components/member/MemberListLink";
import PaginationLink from "@/components/member/PaginationLink";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import memberUtil from "@/components/member/memberUtil";
import EventBus from "../../utils/event-bus";
import DeleteClass from "@/mixins/deleteClass";

const {filterConfig} = memberUtil;

export default {
    name: "MemberListProhibitComponent",
    mixins: [filterMixins, listMixins, alertMixins, memberUtil],
    components: {MemberListLink, PaginationLink},
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            memberListSetData: this.setData,
        }
    },
    inject: ['changeLoading'],
    props: {
        memberType: {default: ''},
        cafeKey: "",

    },
    data() {
        return {
            getFunc: null,
            listLayout: '',
            paginationLayout: '',
            paginationType: '',
            listApiParamSet: {},
        }
    },
    created() {
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
        this.initConfig();
        this.newDeleteClass();
    },
    mounted() {
        this.getList(true);
        EventBus.$on('deleteConfirm', this.deleteConfirm)
        EventBus.$on('writeProhibit', this.writeProhibit)

    },
    beforeDestroy() {
        EventBus.$off('deleteConfirm')
        EventBus.$off('writeProhibit')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let config = this.returnMemberConfig(this.memberType)
            this.getFunc = config.getFunc;
            this.listLayout = config.listLayout;
            this.paginationLayout = config.paginationLayout;
            this.paginationType = config.paginationType;
            this.listApiParamSet = config.listApiParamSet;


            let pageRow = config.pageRow ? config.pageRow : 10;
            if (pageRow != this.filterSet.page.size) {
                this.filterSet.page.size = pageRow;
            }

            let listOptions = {
                url: this.$api.$member[this.getFunc],
                defaultParams: this.listApiParamSet
            }
            this.initList('api', listOptions);
        },
        newDeleteClass() {
            let deleteOptions = {
                func: this.$api.$member.deleteProhibit,
                apiParamSet: {},
                keyName: 'pn_idx',
                successType: 1,
                afterFunc: this.deleteAfterFunc,
            }
            this.DeleteClass = new DeleteClass(deleteOptions);
        },
        deleteConfirm(key) {
            this.createConfirm({
                content: '정말 삭제하시겠습니까?',
                confirm: () => {
                    this.runDelete(key);
                },
            })
        },
        runDelete(key) {
            this.DeleteClass.runDelete(key);
        },
        deleteAfterFunc() {
            let _this = this
            this.createAlert({
                content: '삭제되었습니다.',
                btnText: '확인',
                hide: () => {
                    _this.getList();
                }
            })
        },
        writeProhibit(data) {
            let _this = this
            let params = {
                pn_word: data
            }
            this.$api.$member.createProhibit(params).then(res => res.Data.Result).then(res => {
                let type = this.returnProhibitType(res.Info.type);
                if (type === true) {
                    this.createAlert({
                        content: '저장 되었습니다.',
                        hide() {
                            _this.getList();
                            EventBus.$emit('initSetData');
                        }
                    })
                } else {
                    this.errorAlert(type);
                }
            })
        },
        returnProhibitType(type) {
            if (type === 1) {
                return true
            } else if (type === -403) {
                return '권한이 존재하지않습니다.'
            } else if (type === -100) {
                return '필수값이 존재하지 않습니다.'
            } else if (type === -104) {
                return '금지 닉네임이 존재합니다.'
            }
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
